import styled from 'styled-components';

const BackgroundWrapper = styled.div`
    background-image: url(${props => props.backgroundImg});
    height: 100vh;
    width: 100%;
    justify-content: center;
    display: flex;
    background-position: center;
    ${props => props.alignItems ? `align-items: ${props.alignItems};` : ''}
`;

export default BackgroundWrapper;
